module.exports = __webpack_public_path__ + "static/20260812_Results_ExOffer_ConsSolicitation-e1f7f8363b74011083739de672b139a4.pdf";